import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class Dinied extends Component {
  state = {};
  componentDidMount = () => {
    this.getIpInfo();
    this._getTest();
  };

  _getTest = () => {
    return axios('https://mapi.aniplustv.com:3100/test')
      .then((response) => response)
      .catch((error) => {});
  };

  getIpInfoApi = () => {
    const { apiUrl } = this.props;
    //console.log('aaaaaaaaaaaaa')
    return axios
      .post(apiUrl + '/geoip', {
        params: {},
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  getIpInfo = async () => {
    // const { history, apiUrl } = this.props;
    const result = await this.getIpInfoApi();
    const ip = result.data[0].ip;
    const data = result.data[0].listData;

    //console.log(data)
    this.setState({
      ip: ip || '',
      country: data.country || '',
    });

    /*
          axios.get("http://ip-api.com/json").then(response => {
              let data = response.data || {};
              //console.log(data)
            
              if(data.countryCode === 'KR') {
                //history.push('/dinied')
              } else {
                history.push('/dinied')
              }
    
    
          }).catch((err) => {
             
          });
          */
  };

  render() {
    const { country, ip } = this.state;
    return (
      <Fragment>
        <div
          style={{
            paddingTop: 100,
            width: '100%',
            height: '100%',
            textAlign: 'center',
          }}
        >
          <div>
            <span style={{ color: '#ffffff' }}>
              For the reason of territorial copyright protection,
            </span>
          </div>
          <div>
            <span style={{ color: '#ffffff' }}>
              this web-site may not be accessible in other countries except
              Republic of Korea.
            </span>
          </div>
          <div>
            <span style={{ color: '#ffffff' }}>
              If you have further question, you may contact us by e-mail
              (webmaster@aniplustv.com)
            </span>
          </div>
          <div>
            <span style={{ color: '#ffffff' }}>Country : {country}</span>
          </div>
          <div>
            <span style={{ color: '#ffffff' }}>IP : {ip}</span>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Dinied));
